import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=55d6bfbc&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"
import style0 from "./HomePage.scss?vue&type=style&index=0&id=55d6bfbc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6bfbc",
  null
  
)

export default component.exports